import { Injectable } from '@angular/core';
import { IConnectionOptions, SignalR, ISignalRConnection } from 'ng2-signalr';
import { Subject } from 'rxjs';

import { ConfigService } from 'src/app/shared/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionSignalRService {
  private _connection: ISignalRConnection;
  private _transactionUpdatedErrorListener = new Subject<void>();
  private _factory: string;
  private _isConnected: boolean;
  transactionUpdatedErrorListener$ = this._transactionUpdatedErrorListener.asObservable();

  constructor(private _configService: ConfigService, private _signalR: SignalR) {
    this.connectionHandler();
  }

  connect(factory: string) {
    this._factory = factory;
    let options: IConnectionOptions = { hubName: 'transactionHub', url: this._configService.config.transactionUrl };
    this._signalR.connect(options)
      .then((c) => {
        this._isConnected = true;
        this._connection = c;
        this.listen();
      })
      .catch((err) => {
        this._isConnected = false;
        console.error(`Could not connect to SignalR transaction hub. ${err.toString()}`);
      });
  }

  disconnect() {
    if (this._isConnected)
      this._connection.stop();
  }

  isConnected(): boolean {
    return this._isConnected;
  }

  private listen() {
    this.transactionUpdatedErrorListener();
    this.errorListener();
  }

  private transactionUpdatedErrorListener() {
    this._connection.listenFor('transactionUpdatedErrorListener').subscribe((factory: string) => {
      if (factory === this._factory)
        this._transactionUpdatedErrorListener.next();
    });
  }

  private errorListener() {
    this._connection.errors.subscribe((error: any) => {
      this._isConnected = false;
      console.error(error);
    });
  }

  private connectionHandler() {
    setInterval(() => {
      if (this._isConnected || !this._factory)
        return;

      this.disconnect();
      this.connect(this._factory);
    }, 60000);
  }
}
